module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"pings.gq","short_name":"pings.gq","start_url":"/","background_color":"#fff","theme_color":"#FFAA00","display":"minimal-ui","icon":"src/images/favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"bb591c1b27189563acbbe1a20d8cfa29"},
    }]
